// ============================================================
//  ADMIN — SITE-SETTINGS (Hero-Bereich der Startseite)
// ============================================================
import { useEffect, useState } from "react";
import { fetchSiteSettings, updateSiteSettings } from "../../cms/siteSettings";
import { fotoHochladen } from "../../cms/upload";

const LEER = { heroEyebrow: "", heroTitel: "", heroText: "", heroBild: "", heroCtaLabel: "", heroCtaTo: "" };

export default function Einstellungen() {
  const [daten, setDaten] = useState(LEER);
  const [ladend, setLadend] = useState(true);
  const [hochladen, setHochladen] = useState(false);
  const [speichernLaeuft, setSpeichernLaeuft] = useState(false);
  const [gespeichert, setGespeichert] = useState(false);
  const [fehler, setFehler] = useState("");

  useEffect(() => {
    fetchSiteSettings().then((s) => {
      if (s) setDaten({ ...LEER, ...s });
      setLadend(false);
    });
  }, []);

  async function bildAuswahl(e) {
    const datei = e.target.files?.[0];
    if (!datei) return;
    setHochladen(true);
    setFehler("");
    try {
      const url = await fotoHochladen(datei, "cms");
      setDaten((d) => ({ ...d, heroBild: url }));
    } catch (err) {
      setFehler(err.message);
    } finally {
      setHochladen(false);
      e.target.value = "";
    }
  }

  async function speichern(e) {
    e.preventDefault();
    setSpeichernLaeuft(true);
    setFehler("");
    setGespeichert(false);
    try {
      await updateSiteSettings(daten);
      setGespeichert(true);
    } catch (err) {
      setFehler(err.message);
    } finally {
      setSpeichernLaeuft(false);
    }
  }

  if (ladend) return <p className="mx-auto max-w-3xl px-4 py-16 text-dark/50">Lädt …</p>;

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-2xl font-extrabold uppercase text-primary mb-8">Site-Settings</h1>

      <form onSubmit={speichern} className="space-y-4">
        <label className="block">
          <span className="text-sm font-semibold">Eyebrow (kleiner Text über dem Titel)</span>
          <input value={daten.heroEyebrow} onChange={(e) => setDaten({ ...daten, heroEyebrow: e.target.value })} className="mt-1 w-full border border-dark/20 px-3 py-2" />
        </label>
        <label className="block">
          <span className="text-sm font-semibold">Hero-Titel</span>
          <input value={daten.heroTitel} onChange={(e) => setDaten({ ...daten, heroTitel: e.target.value })} className="mt-1 w-full border border-dark/20 px-3 py-2" />
        </label>
        <label className="block">
          <span className="text-sm font-semibold">Hero-Text</span>
          <textarea rows={3} value={daten.heroText} onChange={(e) => setDaten({ ...daten, heroText: e.target.value })} className="mt-1 w-full border border-dark/20 px-3 py-2" />
        </label>
        <div className="grid sm:grid-cols-2 gap-4">
          <label className="block">
            <span className="text-sm font-semibold">Button-Text</span>
            <input value={daten.heroCtaLabel} onChange={(e) => setDaten({ ...daten, heroCtaLabel: e.target.value })} className="mt-1 w-full border border-dark/20 px-3 py-2" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Button-Ziel (Pfad)</span>
            <input placeholder="/teams" value={daten.heroCtaTo} onChange={(e) => setDaten({ ...daten, heroCtaTo: e.target.value })} className="mt-1 w-full border border-dark/20 px-3 py-2" />
          </label>
        </div>

        <div>
          <span className="text-sm font-semibold">Hero-Bild</span>
          {daten.heroBild && <img src={daten.heroBild} alt="" className="mt-2 h-32 w-full object-cover" />}
          <input type="file" accept="image/*" onChange={bildAuswahl} disabled={hochladen} className="mt-2 text-sm block" />
          {hochladen && <p className="text-sm text-dark/50 mt-1">Lädt hoch …</p>}
        </div>

        {fehler && <p className="text-sm text-red-600">{fehler}</p>}
        {gespeichert && <p className="text-sm text-green-700">Gespeichert.</p>}

        <button type="submit" disabled={speichernLaeuft} className="bg-primary text-white font-bold uppercase text-sm px-6 py-2.5 hover:bg-accent transition-colors disabled:opacity-50">
          {speichernLaeuft ? "Speichert …" : "Speichern"}
        </button>
      </form>
    </div>
  );
}
